module.exports = __webpack_public_path__ + "static/media/signup-background.a0def2d8.png";